<template>
	<assign-table
		ref="table"
		:items
		:headers
		:loading
		stage="stock-check"
		@select="(value: ContractItem[]) => emit('select', value)"
		@update="(value: ContractItem) => emit('update', value)"
		@clicked-item="(value: ContractItem) => emit('clickedItem', value)" />
</template>

<script lang="ts" setup>
	import type { Header } from '@/data/types/datatable'
	import { ref } from 'vue'
	import AssignTable from '../../all/AssignTable.vue'
	import type { ContractItem } from '@/data/schema/contract-item'

	defineProps({
		items: {
			type: Array<ContractItem>,
			default: []
		},
		loading: Boolean
	})

	const table = ref()

	const headers: Header[] = [
		{ value: 'stock_status', text: 'Status' },
		{ value: 'item_number', text: 'Item No', props: { sortable: true } },
		{ value: 'description', text: 'Item Description', props: { sortable: true } },
		{ value: 'type', text: 'Type', props: { sortable: true, width: 100 } },
		{ value: 'delivery_date', text: 'Del Date', props: { sortable: true } },
		{ value: 'quantity_required', text: 'Qty Req', props: { sortable: true } },
		{ value: 'quantity_confirmed', text: 'Qty Conf', props: { sortable: true } },
		{ value: 'assigned', text: 'Assigned', props: { sortable: false, width: 150 } },
		{ value: 'notes', text: 'Notes', props: { sortable: false } }
	]

	// Events
	const emit = defineEmits(['select', 'update', 'clickedItem'])

	// Expose
	defineExpose({ updateOperators })

	/**
	 * Exposed function to bulk update all operators
	 * @param operator string
	 */
	function updateOperators(operator: string) {
		table.value.updateOperators(operator)
	}
</script>
